import T from "i18n-react";
import TextsEs from "./es.json";
import TextsEn from "./en.json";

function getExplorerLanguageOrDefault() {
    const urlParams = new URLSearchParams(window.location.search);
    const defaultLang = urlParams.get('lang');
    if (defaultLang) {
        if (defaultLang === "en")
            return TextsEn;
        
        return TextsEs;
    }

    if (navigator.language !== undefined && "en" === navigator.language.split("-")[0]) {
        return TextsEn;
    } else {
        return TextsEs;
    }
}

export function initTranslator(language: string) {
    switch (language) {
        case "en":
            T.setTexts(TextsEn);
            break;
        case "es":
            T.setTexts(TextsEs);
            break;
        default:
            T.setTexts(getExplorerLanguageOrDefault());
            break;

    }

}

export default function translator(key: string, options?: any) {
    return T.translate(key, options);
}

export function translateParams(params: any) {
    let result = {} as any;
    if (params) {
        Object.keys(params).forEach(key => {
            let translated = translator(`params.${params[key]}`) as string;
            result = { ...result, [key]: translated !== `params.${params[key]}` ? translated : params[key] }
        })
    }
    return result;
}